import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const WifiNoSignalIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M12 19.6L2 8.3C4.82 5.84 8.42 4.54 12 4.54C15.58 4.54 19.18 5.84 22 8.3L12 19.6ZM12 6.4C9.7 6.4 7.36 7 4.68 8.58L12 16.8L19.32 8.58C16.64 7 14.3 6.4 12 6.4Z" />
    </SvgIcon>
  );
});
